@if ((eventLoading$ | async) === false) { @if (event$ | async; as event) {
<section class="event__details">
  <bau365-event-section-header
    [event]="event"
    [exhibitor]="exhibitor"
    [size]="size$ | async"
    [socialShareUrl]="socialShareUrl"
    [breadcrumbElements]="breadcrumbElements"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareDialogOpened)="trackShareDialogOpened($event)"
    (shareDialogClicked)="trackShareDialogClicked($event)"></bau365-event-section-header>
  <bau365-event-section-details [event]="event" [exhibitor]="exhibitor"></bau365-event-section-details>
  <bau365-event-section-info [event]="event"></bau365-event-section-info>
  <bau365-event-section-contributors
    [event]="event"
    [exhibitor]="exhibitor"
    [size]="size$ | async"
    (linkClicked)="trackLinkClicked($event)"></bau365-event-section-contributors>
  <bau365-event-section-actions
    [event]="event"
    [exhibitor]="exhibitor"
    [socialShareUrl]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareDialogOpened)="trackShareDialogOpened($event)"
    (shareDialogClicked)="trackShareDialogClicked($event)"></bau365-event-section-actions>
  @if (exhibitor) {
  <bau365-event-section-contact
    [event]="event"
    [exhibitor]="exhibitor"
    (linkClicked)="trackLinkClicked($event)"></bau365-event-section-contact>
  } @if (filteredEventList$ | async; as eventList) { @if (eventList.length) {
  <bau365-event-section-entity-list [eventList]="eventList" [exhibitor]="exhibitor"></bau365-event-section-entity-list>
  } }
</section>
} @else { @if ((eventError$ | async) !== '500') {
<bau365-shell-page-not-found></bau365-shell-page-not-found>
} @if ((eventError$ | async) === '500') {
<bau365-shell-page-service-unavailable></bau365-shell-page-service-unavailable>
} } } @else {
<section class="event__loadinganimation">
  <planone-loading-animation></planone-loading-animation>
</section>
}
